import { IonContent, IonPage } from '@ionic/react'
import React, { useState } from 'react'
import { useHistory } from 'react-router'
import {
    IdentityQuestionItem,
    deleteIdentityQuestion,
    // updateIdentityQuestion,
} from '../../service/api/knowledge'
import './index.css'
import { DeleteableIcon, AddIcon, MergeIcon } from '../../conf/images'
import { useSelector } from 'react-redux'
import { ReduxStore } from '../../redux/reducers'
import { UserModel } from '../../model/user.model'
import { KnowledgeDetailPage, CombileKnowledgePage } from '../../conf/routePath'
import { getLocalItem } from '../../utils'
import Header from '../../components/Header'
const QuestionDetail: React.FC = () => {
    const history = useHistory<IdentityQuestionItem>()
    // const question = getLocalItem('question_item')
    const userInfo = useSelector<ReduxStore, UserModel>(
        (store) => store.userInfo as UserModel
    )
    const [question] = useState<IdentityQuestionItem | null>(
        getLocalItem('question_item')
    )
    if (!question) return null
    const handleQuestionDelete = async () => {
        try {
            let res = await deleteIdentityQuestion({
                appHash: userInfo.app_hash,
                questionIdList: [question.questionId],
            })
            if (res.data && res.data.deleteIdentityQuestion.successfully) {
                history.goBack()
            }
        } catch (error) {}
    }
    // const handleQuestionUpdate = async () => {
    //     try {
    //         await updateIdentityQuestion({
    //             appHash: userInfo.app_hash,
    //             identityQuestionId: question.questionId,
    //             content: question.userQuestion,
    //         })
    //         setLocalItem('question_item', question)
    //     } catch (error) {}
    // }
    return (
        <IonPage className='question-detail-page'>
            <IonContent className='content'>
                <Header title='新问题详情' />
                {question && (
                    <>
                        <div className='question-wrapper'>
                            {/* <p className='title'>新问题</p> */}
                            <p className='question'>{question.userQuestion}</p>
                            {/* <Input
                                multiple
                                value={question.userQuestion}
                                onChange={(value) =>
                                    setQuestion({
                                        ...question,
                                        userQuestion: value,
                                    })
                                }
                                onBlur={handleQuestionUpdate}
                            /> */}
                        </div>
                        <div className='options'>
                            <div className='options-left'>
                                <p
                                    className='option-add option'
                                    onClick={() =>
                                        history.push(KnowledgeDetailPage, {
                                            ktag_id: userInfo.custom_tag_id,
                                            question: question,
                                        } as any)
                                    }
                                >
                                    <img src={AddIcon} alt='add' />
                                    新增
                                </p>
                                <p
                                    className='option-merge option'
                                    onClick={() =>
                                        history.push(CombileKnowledgePage, {
                                            question: question,
                                        } as any)
                                    }
                                >
                                    <img src={MergeIcon} alt='merge' />
                                    合并
                                </p>
                            </div>
                            <img
                                src={DeleteableIcon}
                                alt='delete'
                                onClick={handleQuestionDelete}
                            />
                        </div>
                    </>
                )}
            </IonContent>
        </IonPage>
    )
}

export default QuestionDetail
